// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CouponEnrollmentBasicEnrollmentProgramIdBasicEnrollmentResponse {
    static getAttributeTypeMap() {
        return CouponEnrollmentBasicEnrollmentProgramIdBasicEnrollmentResponse.attributeTypeMap;
    }
}
CouponEnrollmentBasicEnrollmentProgramIdBasicEnrollmentResponse.discriminator = undefined;
CouponEnrollmentBasicEnrollmentProgramIdBasicEnrollmentResponse.additionalProperties = false;
CouponEnrollmentBasicEnrollmentProgramIdBasicEnrollmentResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "ExtEnrollmentResultModel"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=couponEnrollmentBasicEnrollmentProgramIdBasicEnrollmentResponse.js.map